// extracted by mini-css-extract-plugin
export default {"transactionClose":"styles_transactionClose__jPKBS","head":"styles_head__cb1qO"};